

import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { BlockHeaderGroup } from '~/interfaces/components'
import ArrowRoundedLeft7x11Svg from '~/svg/arrow-rounded-left-7x11.svg'
import ArrowRoundedRight7x11Svg from '~/svg/arrow-rounded-right-7x11.svg'

@Component({
    components: { ArrowRoundedLeft7x11Svg, ArrowRoundedRight7x11Svg }
})
export default class BlockHeader extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string
    @Prop({ type: Boolean, default: () => false }) readonly arrows!: boolean
    @Prop({ type: Array, default: () => [] }) readonly groups!: BlockHeaderGroup[]

    @Emit() prev () { }
    @Emit() next () { }
    @Emit() groupClick (group: BlockHeaderGroup) { return group }
}

